module.exports = __webpack_public_path__ + "img/161.6172f51d.jpg";